var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPointLogo24X24 = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M24 12a6.5 6.5 0 1 0-13.001.001A6.5 6.5 0 0 0 24 12Z",
  fill: "#2E87FF"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M16.735 11.98h1.215c.29 0 .53-.101.722-.303.19-.2.286-.45.286-.746a1.05 1.05 0 0 0-.286-.751.962.962 0 0 0-.722-.296h-1.215V11.979ZM15.37 9.034c0-.234.19-.424.424-.424h2.154c.66 0 1.218.223 1.68.672.455.448.68.997.68 1.65 0 .652-.227 1.202-.68 1.65a2.324 2.324 0 0 1-1.68.671h-1.216v1.525a.681.681 0 1 1-1.362 0V9.035Z",
  fill: "#fff"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M9.6 6H2.415A2.415 2.415 0 0 0 0 8.415v7.169A2.416 2.416 0 0 0 2.415 18h7.169A2.416 2.416 0 0 0 12 15.584V8.4A2.4 2.4 0 0 0 9.6 6Z",
  fill: "#1A2E82"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M3.467 15.528a.779.779 0 1 1-1.558 0 .779.779 0 0 1 1.558 0Z",
  fill: "#2D91FF"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M8.524 12.788c-.255 0-.507.165-.64.334-.406.467-.945.835-1.654.835a1.949 1.949 0 0 1-1.957-1.938c0-1.036.843-1.938 1.957-1.938.709 0 1.248.368 1.653.835.134.169.39.334.641.334.468 0 .788-.352.788-.74a.818.818 0 0 0-.13-.463c-.636-.939-1.664-1.538-2.952-1.538-1.99 0-3.543 1.538-3.543 3.509 0 1.97 1.553 3.508 3.543 3.508 1.282 0 2.316-.599 2.952-1.537a.804.804 0 0 0 .13-.462c0-.386-.322-.741-.788-.741",
  fill: "#fff"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  d: "M3.467 15.528a.779.779 0 1 1-1.558 0 .779.779 0 0 1 1.558 0Z",
  fill: "#2D91FF"
})));
export default SvgPointLogo24X24;